import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Actions as LOGINACTIONS } from "../../store/actions/authenticationActions";
import Select from "react-select";
import XeroLogoBlue from "./xero-logo-blue.svg";
import BuddyFace from "../../assets/images/buddy-face.png";
import FacebookLogin from "react-facebook-login";

import { Link, useLocation } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import LoginForm from "./LoginForm";

const Login = ({
	profile,
	login,
	resetPassword,
	invalidLoginCredentials,
	processing,
	logout,
	sso,
	goToZendesk,
	externalAppLogin,
}) => {
	const [reset, setReset] = useState(false);
	const [username, setUsername] = useState();
	const [password, setPassword] = useState();

	const location = useLocation();
	const referrer = useMemo(() => {
		const referrer = new URLSearchParams(location.search).get("referrer");

		if (referrer === "https://www.buddy.hr/salaryCalculatorEmbed.html") return "/cola-report";
		else return referrer;
	}, [location.search]);

	useEffect(() => {
		if (profile && sso) {
			goToZendesk();
		}
	}, [profile?.id, sso]);

	if (profile) {
		return (
			<div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
				<div className="sm:mx-auto sm:w-full sm:max-w-md mb-8">
					<img
						className="mx-auto h-12 w-auto"
						src={BuddyFace}
						alt="Buddy"
					/>
					<h2 className="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
						Hi, {profile.givenName || profile.name}
					</h2>
					<p className="mt-2 text-center text-sm leading-5 text-gray-600 max-w">
						Welcome back, what would you like to do today?
					</p>
				</div>
				<LoginForm />
			</div>
		);
	}

	return (
		<div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
			<div className="sm:mx-auto sm:w-full sm:max-w-md mb-8">
				<img
					className="mx-auto h-12 w-auto"
					src={BuddyFace}
					alt="Buddy"
				/>
				<h2 className="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
					Sign in to your account
				</h2>
				<p className="mt-2 text-center text-sm leading-5 text-gray-600 max-w">
					Or
					<Link
						to="/"
						className="ml-1 font-medium text-orange-600 hover:text-orange-500 focus:outline-none focus:underline transition ease-in-out duration-150"
					>
						start your free trial
					</Link>
				</p>
			</div>

			<LoginForm />
		</div>
	);
};




const mapStateToProps = (state) => {

  return {
  	profile: state.my.profile,
  	invalidLoginCredentials: state.authentication.invalidLoginCredentials,
  	processing: state.authentication.processing,
  	sso: (window.location.pathname == '/login/sso'),
  }
}

const mapDispatchToProps = dispatch => ({
  login: (username,password) => dispatch(LOGINACTIONS.login(username,password)),
  resetPassword: (username) => dispatch(LOGINACTIONS.resetPassword(username)),
  logout: () => dispatch(LOGINACTIONS.logout()),
  goToZendesk: () => dispatch(LOGINACTIONS.goToZendesk()),
  externalAppLogin: ({ email, externalId, appName, token }) => dispatch(LOGINACTIONS.externalAppLogin({ email, externalId, appName, token })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login) 
